/* @generated from adl module ferovinum.app.invoicing */

import * as ADL from './../../runtime/adl';

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
};
